import { h, Component, createRef, Fragment } from 'preact'
import cn from 'classnames'
import s from './ImageLoader.css'
import Modal from '../Modal'
import CircleButton from '../CircleButton'
import Cropper from '../Cropper'

interface iProps {
  className?: string
  file: File | null
  onChange: (file: File | null) => void
  extensions: string[]
}

interface iState {
  openEditor: boolean
  imageUrl: string
}

class ImageLoader extends Component<iProps, iState> {
  static defaultProps = {
    extensions: ['jpg', 'jpeg', 'png']
  }

  ref = createRef()

  state = {
    openEditor: false,
    imageUrl: ''
  }

  removeImage = () => {
    const { current: input } = this.ref

    this.setState({ imageUrl: '' })
    input.value = ''
  }

  checkExtension = (type: string) => {
    const { extensions } = this.props

    return extensions.find(ext => type.includes(ext))
  }

  changeImage = (e: any) => {
    const { onChange } = this.props
    const { files } = (e as Event).target as HTMLInputElement
    const file = files![0] || e.dataTransfer.files

    if (this.checkExtension(file.type)) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(file)

      fileReader.onloadend = (e: Event) => {
        const imageUrl = (e.target as FileReader).result as string

        this.setState({
          openEditor: true,
          imageUrl
        })

        onChange(file)
      }
    } else {
      this.removeImage()
      onChange(null)
    }
  }

  onCloseEditor = () => {
    this.setState({
      openEditor: false
    })
  }

  onSubmit = (e: Event) => {
    e.preventDefault()

    this.onCloseEditor()
  }

  render () {
    const { className } = this.props
    const { imageUrl, openEditor } = this.state

    return (
      <Fragment>
        <label
          className={cn(
            s.ImageLoader,
            { [s.ImageLoader_active]: imageUrl },
            className
          )}
        >
          <i className={s.ImageLoader__icon}/>

          {imageUrl && (
            <img
              className={s.ImageLoader__image}
              src={imageUrl} alt=""
            />
          )}

          <input
            type="file"
            ref={this.ref}
            className={s.ImageLoader__input}
            onChange={this.changeImage}
          />
        </label>


        <Modal
          isOpen={openEditor}
          onClose={this.onCloseEditor}
        >
          <form
            className={s.ImageLoader__modal}
            onSubmit={this.onSubmit}
          >
            <button
              type="button"
              className={s.ImageLoader__close}
              onClick={this.onCloseEditor}
            />

            <div className={s.ImageLoader__title}>
              Drag to Reposition
            </div>

            <Cropper
              className={s.ImageLoader__crop}
              imageUrl={imageUrl}
            />

            <div className={s.ImageLoader__submit}>
              <CircleButton
                color="blue"
                size="l"
              >
                <i className={s.ImageLoader__check}/>
              </CircleButton>
            </div>
          </form>
        </Modal>
      </Fragment>
    )
  }
}

export default ImageLoader
